export default class WooQuantity {

    cart;
    checkout;

    constructor() {
        this.cart = document.getElementsByClassName('woocommerce-cart-form').length > 0;
        this.checkout = document.getElementsByClassName("woocommerce-checkout").length > 0;
    }

    init() {
        this.decreaseQuantity();
        this.increaseQuantity();
    }
    
    decreaseQuantity() {
        document.addEventListener("click", (event) => {
            if (event.target.matches('.qty-button-minus')) {

                let quantityDiv = event.target.closest('.product-quantity');
                if(!quantityDiv) {
                    quantityDiv = event.target.closest('.quantity');
                }
                const inputNumber = quantityDiv.querySelector('input[type="number"]');
                const inputValue = inputNumber.getAttribute('value');
                if (inputValue > 1 ) {
                    let newValue = parseInt(inputValue, 10) - 1;
                    inputNumber.setAttribute("value", newValue);

                    if(this.checkout) {
                        this.updateCheckout()
                    } else if (this.cart) {
                        this.updateCart();
                    }
                }
                jQuery(`#${inputNumber.id}`).trigger('change');
            }
        });
    }

    increaseQuantity() {
        document.addEventListener("click", (event) => {
            if (event.target.matches('.qty-button-plus')) {

                let quantityDiv = event.target.closest('.product-quantity');
                if(!quantityDiv) {
                    quantityDiv = event.target.closest('.quantity');
                }
                const inputNumber = quantityDiv.querySelector('input[type="number"]');
                const inputValue = inputNumber.getAttribute('value');

                let newValue = parseInt(inputValue, 10) + 1;
                inputNumber.setAttribute("value", newValue);

                if(this.checkout) {
                    this.updateCheckout();
                } else if (this.cart) {
                    this.updateCart();
                }
                jQuery(`#${inputNumber.id}`).trigger('change');
            }
        });
    }
    updateCart() {
        document.querySelector("button[name='update_cart']").removeAttribute("disabled");
        document.querySelector("button[name='update_cart']").click();
    }

    updateCheckout() {
        jQuery('.pro_quantity').trigger('change');
    }
}